module.exports = __webpack_public_path__ + "img/google.239028f4.svg";